import { render, staticRenderFns } from "./AliyunCaptchaModal.vue?vue&type=template&id=4b89df48"
import script from "./AliyunCaptchaModal.vue?vue&type=script&lang=js"
export * from "./AliyunCaptchaModal.vue?vue&type=script&lang=js"
import style0 from "./AliyunCaptchaModal.vue?vue&type=style&index=0&id=4b89df48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports